import React, { useEffect, useState } from "react";
import "../home/index.css";
import { useParams, useHistory, NavLink, Redirect } from "react-router-dom";
import { postData } from "../common/utils";
import { useAlert } from "react-alert";
import alertify from 'alertifyjs';
import 'alertifyjs/build/css/alertify.css';
import { encryptData, generateSignature } from "./../../utils/functions";


const RewardForm = (props) => {
  const alert = useAlert();
  let history = useHistory();
  let { brand } = useParams();
  let { rewardid } = useParams();
  const [brandName, setBrandName] = useState("");
  const [brandLogo, setBrandLogo] = useState("");
  const [rewardAmount, setRewardAmount] = useState(0);
  const [rewards, setRewards] = useState([]);
  const [disabled, setDisabled] = useState(false);
  const [disablOption, setDisableOption] = useState(false);
  const [earnedPats, setEarnedPats] = useState(0);


  let RewardAmount = rewardAmount;
  useEffect(() => {
    fetch(process.env.REACT_APP_API_URL + "api/rewards/" + rewardid + "/" + brand)
      .then((response) => response.json())
      .then((data) => {
        if (data.issuccessful == true) {


          setBrandName(data.reward.RewardName);
          setBrandLogo(data.reward.RewardImage);
          setRewards(data.rewardamt);

        }
      });

    fetch(process.env.REACT_APP_API_URL + "api/user/pats")
      .then((response) => response.json())
      .then((data) => {
        if (data.issuccessful == true) {
          setEarnedPats(data.pats.earnedPats);
        }
      });
    //console.log("yeeeeeeeeeeet", rewards);
  }, [])

  const redeem = (event) => {
    event.preventDefault();
    //console.log(rewardAmount);
    if (rewardAmount == 0) {
      alert.error("Please select valid amount");
    } else {
      setDisabled(true);//Disables submit button(To avoid multiple requests). Shows loading...
      //console.log("Please wait");
      document.getElementById("redeem").innerHTML = "Please Wait...";
      var data = {
        rewardId: encryptData(rewardid),
        RewardAmount: encryptData(rewardAmount),
      };
      postData(
        process.env.REACT_APP_API_URL + "api/rewards/redeem",
        data
      ).then((data) => {
        setDisabled(false);
        
        const signature = data.signature;
        const expectedSignature = generateSignature(data.issuccessful, data.message);
        const isValid = signature === expectedSignature;

        if(isValid){
          if (data.issuccessful == true) {
            //alert.success(data.message);
            alertify.alert('').setHeader('').setContent('We have received your Pats redeem request.<br>The employee engagement team will work on it and inform you when the gift card is sent. <br> <br>Thank you for your patience.').set('label', 'Okay!').show();
            //console.log('Earned pats: ', data.earnedPats);
            history.push("/rewards");
          } else {
            setDisabled(false);
            document.getElementById("redeem").innerHTML = "Redeem!";
            alert.error(data.message);
          }
        } else {
          document.getElementById("redeem").innerHTML = "Redeem!";
          setDisabled(false);
          alert.error("Invalid Signature");
        }
        
      });
    }
  }


  return (
    <section>
      <div>
        <div style={{ display: "flex" }}>
          <NavLink to={"/rewards"} style={{ display: "flex", alignItems: "center", gap: "15px" }}>
            <i class="fa fa-angle-left" style={{ color: "#008bff", fontSize: "30px" }}></i> <span className="back-btn">Back to Rewards</span>
          </NavLink>
        </div>
        <div style={{ marginTop: "40px" }} className="rewardform">
          <img src={process.env.REACT_APP_REWIMG_URL + brandLogo} />
          <form>
            <label style={{ display: "block" }}>Pats to Redeem:</label>
            {/* <input type="number"  className="form_input"></input>
            <p  className="value">Min value: 100 and Max value: 10,000</p> */}
            <select onChange={(e) => setRewardAmount(e.target.value)} value={rewardAmount} name="rewardAmount" style={{ border: "1px solid rgb(134,140,204)", borderRadius: "8px", padding: "10px", cursor: "pointer", boxSizing: "border-box" }}>
              <option value="0">Select Denomination</option>
              {rewards.map((element, index) => {
                return (<> {
                  //earnedPats >= element && 
                  <option value={element}>{element}</option>}
                </>

                );
              })

              }
            </select>
            <button id="redeem" style={{ display: "block", marginTop: "25px", width: "max-content" }} onClick={redeem} disabled={disabled} className="blue-btn pf-btn">
              Redeem!
            </button>

          </form>
        </div>

      </div>
    </section>
  );
}

export default RewardForm;
